import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var context = require.context('./components', true, /\.(vue)$/);
var components = {};
context.keys().forEach(function (filename) {
  var c = context(filename).default;
  var id = filename.match(/\/([^/]+)\.vue$/)[1];
  components[id] = c;
});
export default components;